import React from 'react';
import pluralize from 'pluralize';
import Text from '@/components/ui/Text';
import PrimaryImageIcon from './PrimaryImageIcon';

const DuplicatesBanner = ({ numDuplicates }) => {
  const pluralizedImagesText = pluralize('image', numDuplicates);

  return (
    <div
      className="tw-max-w-full tw-bg-[#fcf7ee] tw-border tw-border-orange tw-border-solid tw-rounded-lg tw-px-3 tw-py-1"
    >
      <Text className="!tw-text-[#933615]" size="sm" weight="bold">
        {numDuplicates} Duplicate {pluralizedImagesText} detected
      </Text>
      <Text className="" size="sm" tag="div">
        The image you&apos;re uploading appears similar to existing images.
        First, review the images and confirm if they are duplicates.
        If they are duplicates, choose a
        <strong>&nbsp;Primary&nbsp;</strong>
        <PrimaryImageIcon />
        &nbsp;image, then click &quot;Merge Images&quot;.
      </Text>
    </div>
  );
};

export default DuplicatesBanner;
